<template>
  <q-dialog
    v-model="shown"
  >
    <q-card
      :style="{
        'width': $q.screen.gt.xs ? '500px' : '100%',
        'max-width': '500px'
      }"
    >
      <q-form
        ref="formRef"
      >
        <q-card-section
          v-if="carouselItem"
          class="q-pb-none"
        >
          <div class="column">
            <div class="row items-center q-gutter-sm">
              <div class="col text-h6">
                {{ formTitle }}
              </div>
              <q-btn
                class="col-auto"
                icon="close"
                flat
                round
                dense
                @click="close"
              />
            </div>
            <div class="row q-col-gutter-sm items-start">
              <div class="col-8 column q-col-gutter-sm">
                <div class="text-h7">
                  Main Image
                </div>
                <!-- NOTE: We must pass :model="sectionClone" to all of these for the reasons explained
              in the code comments for `initializeSectionClone()` -->
                <model-form-image-uploader
                  :model="sectionClone"
                  :field="`config.carousel.items[${index}].image`"
                  value-type="String"
                  min-height="190px"
                  style="max-width: 220px;"
                  :image-url="carouselItemImageUrl(localizedCarouselItem.image)"
                />
              </div>
              <div class="col-4 column q-col-gutter-md">
                <div class="text-h7">
                  Mobile Only Image
                </div>
                <model-form-image-uploader
                  :model="sectionClone"
                  :field="`config.carousel.items[${index}].mobileImage`"
                  value-type="String"
                  class="col"
                  min-height="80px"
                  :image-url="carouselItemImageUrl(localizedCarouselItem.mobileImage)"
                />
              </div>
            </div>
            <div class="row q-col-gutter-sm items-start q-mt-md">
              <q-select
                v-model="carouselItemMovie"
                class="col"
                label="Select Movie to Autofill"
                :options="movies.data"
                option-label="name"
                outlined
                clearable
                :use-input="true"
                input-style="search"
                debounce="100"
                stack-label
                @filter="filterMovies"
                @update:model-value="selectMovie"
              />
            </div>
            <div class="row q-col-gutter-sm items-start q-mt-md">
              <model-form-input
                :model="sectionClone"
                :field="`config.carousel.items[${index}].title`"
                value-type="String"
                class="col"
                label="Title"
                :rules="[val => !!val || 'Field is required']"
              />
              <model-form-toggle
                :model="sectionClone"
                :field="`config.carousel.items[${index}].showTitle`"
                value-type="Boolean"
                class="col-auto q-my-auto q-mr-md"
                label="Show Title"
                bottom-slots
                size="lg"
              />
            </div>
            <div
              class="row q-col-gutter-sm items-start"
            >
              <model-form-input
                :model="sectionClone"
                :field="`config.carousel.items[${index}].description`"
                value-type="String"
                type="textarea"
                autogrow
                class="col"
                label="Description"
              />
            </div>
            <div class="row q-col-gutter-md items-start q-mt-xs">
              <model-form-input
                :model="sectionClone"
                :field="`config.carousel.items[${index}].startDate`"
                :value-type="IsoDate"
                class="col-6"
                label="Start Date"
                clearable
                :rules="[
                  () => !carouselItem.startDate || !carouselItem.endDate || carouselItem.startDate <= carouselItem.endDate || 'Date cannot postdate end date',
                ]"
              />
              <model-form-input
                :model="sectionClone"
                :field="`config.carousel.items[${index}].endDate`"
                :value-type="IsoDate"
                class="col-6"
                label="End Date"
                clearable
                :rules="[
                  () => !carouselItem.endDate || !carouselItem.startDate || carouselItem.endDate >= carouselItem.startDate || 'Date cannot predate start date',
                ]"
              />
            </div>
            <div
              class="row q-col-gutter-sm items-start"
            >
              <model-form-checkbox
                :model="sectionClone"
                :field="`config.carousel.items[${index}].darkMode`"
                value-type="Boolean"
                class="col-4"
                label="Light Text"
              />
              <model-form-checkbox
                :model="sectionClone"
                :field="`config.carousel.items[${index}].hasLink`"
                value-type="Boolean"
                class="col-4"
                label="Has Url Link"
              />
              <model-form-checkbox
                v-if="carouselItem.hasLink"
                :model="sectionClone"
                :field="`config.carousel.items[${index}].openInNewTab`"
                value-type="Boolean"
                class="col-4"
                label="Open Link in New Tab"
              />
            </div>
            <div class="row q-col-gutter-sm items-start">
              <model-form-input
                v-if="carouselItem.hasLink"
                :model="sectionClone"
                :field="`config.carousel.items[${index}].linkUrl`"
                value-type="String"
                class="col"
                label="Link Url"
                :rules="[val => val !== null || 'Field is required']"
              />
            </div>
            <div
              class="row q-col-gutter-sm items-start"
            >
              <model-form-checkbox
                :model="sectionClone"
                :field="`config.carousel.items[${index}].showButton`"
                value-type="Boolean"
                class="col-6"
                label="Show Button"
              />
              <model-form-input
                v-if="carouselItem.showButton"
                :model="sectionClone"
                :field="`config.carousel.items[${index}].buttonText`"
                value-type="String"
                class="col-6"
                label="Button Text"
                :rules="[val => !!val || 'Field is required']"
              />
            </div>
            <div
              class="row q-col-gutter-sm items-start"
            >
              <model-form-checkbox
                :model="sectionClone"
                :field="`config.carousel.items[${index}].showVideo`"
                value-type="Boolean"
                class="col-6"
                label="Show Video"
              />
              <template
                v-if="carouselItem.showVideo"
              >
                <model-form-select
                  :model="sectionClone"
                  :field="`config.carousel.items[${index}].videoPlatform`"
                  value-type="String"
                  class="col-6"
                  :options="$mh.asOptions(VIDEO_PLATFORM_OPTIONS.ALL)"
                  map-options
                  emit-value
                  label="Video Platform"
                />
                <model-form-input
                  v-if="carouselItem.videoPlatform === VIDEO_PLATFORM_OPTIONS.YOUTUBE"
                  :model="sectionClone"
                  :field="`config.carousel.items[${index}].youtubeVideoId`"
                  value-type="String"
                  class="col-12"
                  label="Youtube Video Id"
                  :rules="[val => !!val || 'Field is required']"
                >
                  <template #hint>
                    <q-icon
                      color="warning"
                      name="info"
                    />
                    <span class="text-dark">Youtube videos don't support auto-play on mobile devices. If you want your video to play on all devices, please choose Vimeo as your video platform.</span>
                  </template>
                </model-form-input>

                <model-form-input
                  v-if="carouselItem.videoPlatform === VIDEO_PLATFORM_OPTIONS.VIMEO"
                  :model="sectionClone"
                  :field="`config.carousel.items[${index}].vimeoVideoId`"
                  value-type="String"
                  class="col-12"
                  label="Vimeo Video Id"
                  :rules="[val => !!val || 'Field is required']"
                />
                <template v-if="allowVideoBackground">
                  <model-form-checkbox

                    :model="sectionClone"
                    :field="`config.carousel.items[${index}].showVideoButton`"
                    value-type="Boolean"
                    class="col-6"
                    label="Show Play Video Button"
                  />
                </template>
                <model-form-input
                  :model="sectionClone"
                  :field="`config.carousel.items[${index}].buttonLabel`"
                  value-type="String"
                  class="col-6"
                  label="Video Button Text"
                  :rules="[val => !!val || 'Field is required']"
                />
              </template>
            </div>
          </div>
        </q-card-section>
        <q-card-actions class="row justify-end q-mb-xl">
          <q-btn
            :label="formSaveLabel"
            color="primary"
            @click="save()"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { CAROUSEL_TYPES, VIDEO_PLATFORM_OPTIONS } from 'src/models/carousel/Carousel'
import { carouselItemImageUrl, createCarouselItem } from 'src/models/carousel/CarouselItem'
import { IsoDate } from 'src/models/Model'
import SectionConfigArrayElementFormMixin from 'src/modules/admin/components/ModelForm/mixins/SectionConfigArrayElementFormMixin'
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

export default {
  name: 'GenericCarouselForm',
  mixins: [SectionConfigArrayElementFormMixin, FormValidationMixin],
  props: {
    carouselType: {
      type: String,
      required: true
    }
  },
  emits: ['save'],
  data () {
    return {
      movieSearchString: '',
      carouselItemMovie: null
    }
  },
  configuration: ['currentCircuit', 'currentSite'],
  computed: {
    allowVideoBackground () {
      return this.carouselType === CAROUSEL_TYPES.CAROUSEL
    },
    // required by mixin
    field () {
      return 'carousel.items'
    },
    // required by mixin
    typeName () {
      return 'Carousel Item'
    },
    carouselItem () {
      return this.currentArrayElement
    },
    localizedCarouselItem () {
      if (!this.carouselItem) return null
      const localizedCarouselItem = { ...this.carouselItem }
      localizedCarouselItem.image = this.carouselItem[this.localizeKey('image')] || this.carouselItem.image
      localizedCarouselItem.mobileImage = this.carouselItem[this.localizeKey('mobileImage')] || this.carouselItem.mobileImage
      return localizedCarouselItem
    }
  },
  created () {
    _.extend(this, { carouselItemImageUrl, CAROUSEL_TYPES, VIDEO_PLATFORM_OPTIONS, IsoDate })
  },
  models: {
    movies: {
      variables () {
        return {
          searchString: this.movieSearchString,
          orderBy: 'createdAt',
          descending: true,
          limit: 5
        }
      }
    }
  },
  methods: {
    // required by mixin
    getElementDefaultProps () {
      return createCarouselItem()
    },
    save () {
      this.validateForm(() => {
        this.carouselItemMovie = null
        this.$emit('save', _.clone(this.carouselItem))
        this.close()
      })
    },
    filterMovies (val, update, abort) {
      update(() => {
        this.movieSearchString = val
      })
    },
    selectMovie (movie) {
      if (!movie) {
        this.resetMovieData()
      }

      this.carouselItem.title = movie.name
      this.carouselItem.hasLink = true
      this.carouselItem.linkUrl = movie.pagePath
      this.carouselItem.youtubeVideoId = movie.trailerYoutubeId
      this.carouselItem.image = this.carouselItemMovie?.bannerImage
      this.carouselItem.mobileImage = this.carouselItemMovie?.bannerImage
    },
    resetMovieData () {
      this.carouselItem.title = ''
      this.carouselItem.hasLink = false
      this.carouselItem.linkUrl = ''
      this.carouselItem.youtubeVideoId = ''
      this.carouselItem.image = ''
      this.carouselItem.mobileImage = ''
    }
  }
}

</script>
